import styled from 'styled-components';

export default styled.section`
  border-radius: 12px;

  background-color: #fff;
  box-shadow: 0rem 0rem 0.25rem 0.25rem #e8e8e8;

  & + & {
    margin-top: 30px;
  }
`;
